export const iconFontAwesomeCampingTree = (
	<i className="fa-solid fa-tree"></i>
);
